import { FC } from 'react';
import { useKeycloak } from '@/providers/keycloak-provider';
import { getInitials } from '@/utils/get-initials';

interface UserInitialsProps {
  className?: string;
  size?: 'sm' | 'lg';
}

const UserInitials: FC<UserInitialsProps> = ({ className = '', size = 'lg' }) => {
  const { keycloak } = useKeycloak();

  const name = keycloak?.tokenParsed?.name;
  const textSize = size === 'lg' ? 'text-2xl' : 'text-sm';

  const initials = getInitials(name || '');

  return (
    <div
      className={`bg-primary-500 flex items-center justify-center rounded-full font-bold text-white ${className}`}
    >
      <span className={`${textSize}`}>{initials}</span>
    </div>
  );
};

export default UserInitials;
